module.exports = __webpack_public_path__ + "static/media/Share.49ac0b01.svg";